import { writable } from 'svelte/store';

export const activeStep = writable(0);
export const selection = writable({});
